import * as React from 'react';
import {View} from 'react-native';
import {Field} from 'redux-form';
import {CheckboxField} from '../../../../../screens/profile/desktop/components/applicationsFilterVisuallyImpaired/components/checkboxField';
import {useStyles} from '../../../../hooks/styles';
import {DeviceSize} from '../../../../theme/helpers';
import {BaseFieldWrapper} from '../../../baseField';
import {getAcceptorsFilterName} from '../../pipes';
import {Props} from './model';

interface ViewProps extends Props {}

export default ({acceptorCategories, style, visuallyImpaired}: ViewProps) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    item: {
      ...mediaOnly(DeviceSize.mobile, {marginBottom: 12}, {marginBottom: 15}),
    },
    label: {
      ...mediaOnly(
        DeviceSize.mobile,
        {
          ...theme.fonts.body,
        },
        {
          ...theme.fonts.caption,
          fontSize: 20,
          lineHeight: 26,
        },
      ),
      color: theme.color.textColor,
    },
    fieldStyle: visuallyImpaired
      ? {
          justifyContent: 'flex-start',
          paddingHorizontal: 10,
        }
      : {},
  }));

  return (
    <View style={style}>
      <View key={0} style={styles.item}>
        <Field
          component={visuallyImpaired ? CheckboxField : BaseFieldWrapper}
          type='checkbox'
          name={getAcceptorsFilterName(String(0), 'category')}
          label={'Все'}
          labelStyle={styles.label}
          style={styles.fieldStyle}
        />
      </View>
      {acceptorCategories
        ? acceptorCategories.map(({id, name}) => (
            <View key={id} style={styles.item}>
              <Field
                component={visuallyImpaired ? CheckboxField : BaseFieldWrapper}
                type='checkbox'
                name={getAcceptorsFilterName(String(id), 'category')}
                label={name}
                labelStyle={styles.label}
                style={styles.fieldStyle}
              />
            </View>
          ))
        : null}
    </View>
  );
};
